export default __webpack_public_path__ + "static/media/stop-watch.efd0582b.png";